<template>
	<search-list ref="sl" apiPath="/advOffer/list" :where="where" :order="order" notSearchAll :searchKeys="searchKeys" >
		<mm-lc title="Time">
			<mm-month-picker v-model="where.time" />
		</mm-lc>
		<mm-lc title="Advertiser">
			<mm-adv-select v-model="where.adv_id" multiple/>
		</mm-lc>
		<mm-lc title="Manager">
			<mm-users v-model="where.manager" multiple></mm-users>
		</mm-lc>
		<mm-lc title="Auth Manager" v-show="is_show_auth">
			<mm-users v-model="where.auth_manager" multiple not_admin></mm-users>
		</mm-lc>
		<mm-lc title="Operator">
			<mm-users v-model="where.operator" multiple></mm-users>
		</mm-lc>
        <mm-lc title="Amount Status">
            <mm-offer-amount-status :showMoreOptions="false" v-model="where.status" multiple />
		</mm-lc>
        <mm-lc title="Is Follow">
            <el-switch v-model="where.is_follow" />
		</mm-lc>
		<!-- <div class="switch-select" slot="switchActions">
			<div class="switch-actions">
				<span>MMP Only:&nbsp;&nbsp;</span>
				<el-switch v-model="where.manual" :active-value="1" :inactive-value="null" />
			</div>
			<div class="switch-actions">
				<span>API Only:&nbsp;&nbsp;</span>
				<el-switch v-model="where.manual" :active-value="0" :inactive-value="null" />
			</div>
		</div> -->
		<template slot="statusAction">
			<el-dropdown size="mini" trigger="click">
				<el-button size="small" type="primary">
					<i class="el-icon-edit"></i>Change Status
				</el-button>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item class="status-deducted" @click.native="changeStatus('deducted')">Switch to Deducted</el-dropdown-item>
					<el-dropdown-item class="status-processing" @click.native="changeStatus('processing')">Switch to Processing</el-dropdown-item>
					<el-dropdown-item class="status-holdon" @click.native="changeStatus('hold on')">Switch to Hold On</el-dropdown-item>
					<el-dropdown-item class="status-confirm" @click.native="changeStatus('confirm')">Switch to Confirm</el-dropdown-item>
					<el-dropdown-item class="status-confirm" @click.native="changeStatus('confirmdelay')">Switch to ConfirmDelay</el-dropdown-item>
					<el-dropdown-item class="status-confirm" @click.native="changeStatus('notrunning')">Switch to NotRunning</el-dropdown-item>
					<el-dropdown-item @click.native="()=>showSelectTime=true">Switch to Chargeback</el-dropdown-item>
					<el-dropdown-item class="status-totoro" @click.native="changeStatus('processing', '', 'totoro')">Switch to Totoro</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</template>
		<!-- <el-button slot="actions" type="success" class="el-icon-document-add" @click="showAddDialog = true"></el-button> -->
		<mm-table slot="dataTable" slot-scope="res" :res="res" @sort-change="sortChange" @selection-change="selectOffer">
			<template slot-scope="etc">
			<el-table-column type="selection"></el-table-column>
			<el-table-column label="Time" prop="period" fixed />
			<el-table-column label="Adv name" prop="adv_name" fixed>
				<mm-get-detail slot-scope="sp" :row_name="sp.row.adv_name" :row_id="sp.row.adv_id" row_type="adv" />
			</el-table-column>
			<el-table-column label="Adv Offer Id" prop="adv_offer_id" :renderHeader="etc.renderHeaderCopy"/>
			<el-table-column label="Offer Id" width="125"  :renderHeader="etc.renderHeaderCopy" prop="offer_id" fixed/>
			<el-table-column label="Offer Name" prop="offer_name" width="150" >
				<span slot-scope="sp">
					<mm-get-detail v-if="!sp.row.manual"  row_type="offer" :row_id="sp.row.offer_id" :row_name="sp.row.offer_name" />
					<mm-get-detail v-if="sp.row.manual" row_type="mmp_offer" :row_id="sp.row.offer_id+','+sp.row.period" :row_name="sp.row.offer_name"></mm-get-detail>
				</span>
			</el-table-column>
			<el-table-column label="Package Id" prop="package_id" width="105"/>
			<mm-summary-column label="Conv" prop="conv" sortable="custom" />
			<mm-summary-column label="Offer Rev" prop="snt_offer_rev" width="120" sortable="custom" />
			<mm-summary-column label="Amount" prop="amount" width="110" sortable="custom" />
			<el-table-column label="Manager" fixed="right" prop="manager" />
			<el-table-column label="Operator" fixed="right" prop="operator" />
			<el-table-column label="Status" fixed="right" prop="status">
				<el-tooltip slot-scope="sp" class="item" effect="dark" :content="sp.row.chargeback" placement="left">
					<span :class="`status-${sp.row.status} status-${sp.row.display_status}`">{{sp.row.display_status.toUpperCase() || sp.row.status.toUpperCase()}}</span>
				</el-tooltip>
			</el-table-column>
			<el-table-column fixed="right" label="action">
				<template slot-scope="sp">
					<el-button type="warn" @click="edit(sp.row)">Edit</el-button>
				</template>

			</el-table-column>
			</template>
		</mm-table>
		<el-dialog :visible.sync="showSelectTime" width="30%">
			<span slot="title">Chargeback Time</span>
			<el-form>
				<el-form-item label="chargebackTime" required>
						<el-date-picker v-model="chargebackTime" popper-class="popper-date" type="month" placeholder="Select"/>
				</el-form-item>
				<el-form-item class="form-item">
					<el-button type="primary" @click="offerChargeback">Save</el-button>
				</el-form-item>
			</el-form>

		</el-dialog>

		<el-dialog :visible.sync="showAddDialog">
			<span slot="title">Add Adv mmp Offer</span>
			<el-form label-width="200px" :model="addForm" ref="addForm">
				<el-form-item label="MMP Offer Id" required prop="offer_id">
					<el-input v-model.trim="addForm.offer_id" style="width:300px"/>
				</el-form-item>
				<el-form-item label="Time" required prop="time">
					<el-date-picker append-to-body v-model="addForm.time" type="month" value-format="yyyy-MM" style="width:300px"/>
				</el-form-item>
				<el-form-item class="form-item">
					<el-button type="primary" @click="addAdvOffer">Save</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</search-list>
</template>

<script>
export default {
	data() {
		const searchKeys = {
			adv_offer_id: { label: "Adv Offer Id" },
			offer_id: { label: "Offer Id" },
			offer_name: { label: "Offer Name" },
			package_id: { label: "Package Id"}
		};
		const user_info = this.$utils.getCookies(['group_name']);
		const is_show_auth = (user_info.group_name === 'admin');
		return {
			searchKeys,
			where: {
				chargeback: '',
			},
			order:[['snt_offer_rev','desc']],
			offer_arr:[],
			showSelectTime: false,
			chargebackTime: '',
			showChargeback: false,
			is_show_auth,
			showAddDialog: false,
			addForm: {},
		};
	},
	methods: {
		edit(row){
			window.open(`/advOfferEdit?id=${row.id}`);
		},
		async sortChange(column){
			const order = this.order;
			if(column.order == 'ascending'){
				order[0] = [column.prop, 'asc'];
			}else if(column.order == 'descending'){
				order[0] = [column.prop, 'desc']
			}else {
				order[0] = ['snt_offer_rev', 'desc']
			}
			await this.$refs.sl.refresh();
		},
		selectOffer(offer_arr){
			this.offer_arr = offer_arr;
		},
		async changeStatus(status, chargeback = '', display_status = ''){
			if(this.offer_arr.length == 0){
				this.$message({
					type:'error',
					message:'Nothing Change'
				});
				return;
			}
			const ids = [];
			for(const offer of this.offer_arr){
				ids.push(offer.id);
			}
			const result = await this.$post('/advOffer/updateAll',{status:status,ids:ids, chargeback, display_status});
			if(result){
				this.$refs.sl.refresh();
			}

		},
		offerChargeback() {
			const chargeback = this.$utils.date_format(this.chargebackTime, 'YYYY-MM');
			this.changeStatus('deducted', chargeback);
			this.showSelectTime = false;
		},
		async addAdvOffer() {
			await this.$validate(this.$refs.addForm);
            await this.$post('advOffer/create',this.addForm);
			await this.$refs.sl.refresh();
			this.showAddDialog = false;
		}
	}
};
</script>

<style scoped>
.bt-create {
  position: relative;
  right: 0px;
}

.switch-select {
	display: flex;
	align-items: center;
	padding-left: 20px;
	font-size: 13px;
}
.switch-actions {
	padding-right: 10px;
}
.switch-action {
	display: flex;
	justify-content: space-between;
	padding-bottom: 10px;
}
</style>

<style>
.popper-date {
	z-index: 3000 !important;
}
</style>
